'use memo';

import { Outlet, createFileRoute, useLocation, useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import { SimpleYearMonthPicker } from '@/components/DatePicker/SimpleYearMonthPicker';
import FillScreen from '@/components/Layout/FillScreen';
import { ContractAndCostToolbar, type ContractAndCostSection } from '@/features/contract-and-cost/contract-and-cont-toolbar/ContractAndCostToolbar';
import { formatPeriod, getDefaultPeriod, parsePeriodStart } from '@/features/contract-and-cost/period';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/contract-and-cost/_contract-and-cost')({
  component: SalaryContractAndCostLayout
});
const PERIOD_PATH_REGEX = /\/contract-and-cost\/(payment|cost)\/(\d{6}_\d{6})/;

/** 賃金は従業員へ直接支払うため、社外取引（見積・発注・請求）のセクションを持たない。 */
const SECTIONS: readonly ContractAndCostSection[] = ['payment', 'cost'];
function SalaryContractAndCostLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const section: ContractAndCostSection = location.pathname.includes('/contract-and-cost/cost') ? 'cost' : 'payment';
  const periodMatch = location.pathname.match(PERIOD_PATH_REGEX);
  const rawPeriod = periodMatch?.[2];
  const periodStart = useMemo(() => rawPeriod ? parsePeriodStart(rawPeriod) : undefined, [rawPeriod]);
  const handleSectionChange = useCallback((newSection: ContractAndCostSection) => {
    // deal は SECTIONS から外しているため到達しない
    if (newSection === 'deal') return;
    const period = rawPeriod ?? getDefaultPeriod();
    navigate({
      to: `/salary-and-wages-mock/contract-and-cost/${newSection}/${period}`
    });
  }, [navigate, rawPeriod]);
  const handlePeriodChange = useCallback((value: {
    year: number;
    month: number;
  } | undefined) => {
    if (value) {
      const newPeriod = formatPeriod(value.year, value.month);
      navigate({
        to: `/salary-and-wages-mock/contract-and-cost/${section}/${newPeriod}`
      });
    }
  }, [navigate, section]);
  return <FillScreen className="flex flex-col">
      <ContractAndCostToolbar value={section} onValueChange={handleSectionChange} sections={SECTIONS} rightContent={<SimpleYearMonthPicker value={periodStart} onChange={handlePeriodChange} className="w-32 bg-white" />} />
      <Outlet />
    </FillScreen>;
}